module.exports = __webpack_public_path__ + "media/images/ideal-vision-center-51600ef9bbb5c1cd227baecb349c28df.webp";